import {NumberField} from '@wandb/components';
import React, {useCallback, useState} from 'react';

import {useDebouncedValue} from '../../../../../util/useDebouncedValue';
import {
  useMediaMaxYAxisCountDisplay,
  useShouldShowMediaMaxYAxisCountResetAtLevel,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const MaxRowCount = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const maxYAxisCount = useMediaMaxYAxisCountDisplay(settingsLevel, panelRef);
  const isSetAtLevel = useShouldShowMediaMaxYAxisCountResetAtLevel(
    settingsLevel,
    panelRef
  );
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({maxYAxisCount: value});
    },
    [updateConfig]
  );

  const {
    value: debouncedMaxRowCount,
    debouncedSetValue: debouncedUpdateConfig,
  } = useDebouncedValue<number>(maxYAxisCount, 500, updateConfigCallback);

  const [maxRowCount, setMaxRowCount] = useState(debouncedMaxRowCount);

  const onChangeInput = (value?: number) => {
    if (value != null) {
      setMaxRowCount(value);
      debouncedUpdateConfig(value);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <SettingTitle
        title="Rows"
        configField="maxYAxisCount"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('maxYAxisCount')}
      />
      <div data-test="max-row-count-input">
        <NumberField
          minValue={0}
          maxValue={50}
          step={1}
          value={maxRowCount}
          onChange={onChangeInput}
        />
      </div>
    </div>
  );
};
